import React, { useEffect } from 'react'
import { Product } from '@user/store/roles/typings'
import { CreateUpdateSideDrawer } from './CreateUpdateSideDrawer'
import { Formik } from 'formik'
import { useFormWrapper } from './hooks/useFormWrapper'
import { LoadingSpinner, SideDrawer } from '@sales-center/components'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { useReadRole } from '@user/store/roles/hooks'

type Props = {
  open: boolean
  onClose: () => void
  products: Product[]
  roleId?: number
}

export function CreateUpdateSideDrawerWrapper(props: Props) {
  const { roleId, products } = props

  const { status, role, execute: onEdit } = useReadRole()

  const { validate, initialValues, onSubmit } = useFormWrapper({
    role,
    products,
    onClose: props.onClose,
  })

  const tidalThemeActive = useTidalThemeActive()

  useEffect(() => {
    if (roleId) onEdit(roleId)
  }, [onEdit, roleId])

  return (
    <SideDrawer
      open={props.open}
      title={roleId ? 'Edit Role' : 'Add Role'}
      onClose={props.onClose}
      tidalThemeActive={true}
      titleVariant="h5"
      titleWeight={tidalThemeActive ? undefined : 800}
      width={495}
    >
      {status === 'pending' && <LoadingSpinner />}
      {(status === 'success' || !roleId) && (
        <Formik
          enableReinitialize
          onSubmit={onSubmit}
          validate={validate}
          initialValues={initialValues}
        >
          <CreateUpdateSideDrawer {...props} role={role} />
        </Formik>
      )}
    </SideDrawer>
  )
}
